<template>
  <NuxtTime v-bind="{ datetime, locale, ...dateTimeFormats[format] }" />
</template>

<script lang="ts" setup>
type DateTimeProps = {
  datetime: Date | string
  format: DateTimeFormat
  locale?: string
}

defineProps<DateTimeProps>()
</script>
